module.exports = "<p>\n  offerbuy works!\n</p>\n"